<div
[class.open]="currentMobileState"
class="comments-wrapper">
  <!-- COMMENTS HEADER -->
  <div
    class="comments-header"
    [class.comments-header-mobile-open]="currentMobileState"
    (click)="toggleContainerState()"
  >
    <ng-content select="div.manager-wrapper"></ng-content>
    <div class="author-box-wrapper">
      <ng-content select="[unh-author-box]"></ng-content>
      <mat-icon class="unh-mobile-arrow" svgIcon="unh_arrow_comments"></mat-icon>
    </div>

  </div>

  <!-- COMMENTS BODY -->
  <div class="comments-body">
      <!-- <div class="ratings-container">
        <div class="ratings-item">
          <h3>4.0</h3>
          <p>Criação</p>
        </div>
        <div class="ratings-item">
          <h3>2.4</h3>
          <p>Storytelling</p>
        </div>
        <div class="ratings-item">
          <h3>5</h3>
          <p>Breakdown</p>
        </div>
      </div> -->
      <h3 *ngIf="comments?.length > 0">
          Comentários
          <!-- <span>[{{postData.length}}]</span> -->
      </h3>

      <!-- COMMENTS -->
      <ng-container *ngFor="let comment of comments; trackBy: trackByFn;">
          <div class="comment-item-wrapper" [id]="'c'+ comment.postpartcommentid">
              <ng-container
                  [ngTemplateOutlet]="commentTemplateRef"
                  [ngTemplateOutletContext]="{ $implicit: comment }"
              ></ng-container>
              <div class="comment-replies" *ngIf="comment.replies" >
                  <ng-container *ngFor="let replyComment of comment.replies; trackBy: trackByFn;">
                      <ng-container
                          [ngTemplateOutlet]="commentTemplateRef"
                          [ngTemplateOutletContext]="{ $implicit: replyComment, isreply: true }"
                      ></ng-container>
                  </ng-container>
              </div>
          </div>
      </ng-container>

      <!-- LOAD MORE -->
      <div class="load-more" *ngIf="showLoadmore && comments?.length > 0">
          <div class="btn-container">
              <a
                  mat-button
                  theme="white-pink-outline"
                  class="unh-button-old"
                  (click)="submitFetchMoreComments()"
              >
                  Carregar mais comentários
              </a>
          </div>
      </div>

      <!-- No Comments || Not Logged -->
      <div class="comments-alert" [class.no-comments]="!luss.isLogged || !comments || comments.length === 0">
        <ng-container *ngIf="!comments || comments.length === 0">
          <p>
            Este projeto ainda não recebeu comentários.
          </p>

          <span>
            Seja o primeiro!
          </span>
        </ng-container>

        <ng-container *ngIf="!luss.isLogged">
          <p *ngIf="comments?.length > 0">
            É necessário estar logado para interagir
          </p>

          <span>Faça seu login para comentar!</span>

          <a
            mat-button
            theme="pink-white"
            class="unh-button-old"
              href="/login"
            >
              Fazer login
            </a>

            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/my-courses/octopus.png" *ngIf="!comments || comments.length === 0">
          </ng-container>
        </div>

        <!-- ROOT COMMENT -->
        <div *ngIf="luss?.isLogged" class="root-comment">
          <div class="comment-field">
            <div class="comment-avatar">
              <unh-user-avatar
                [avatarUrl]="userAvatarUrl"
                [username]="luss.user.alias"
                [uid]="luss.user.uid"
                [userSubscribed]="luss.subscribed"
                [hasUnreadNotifs]="false"
                [redirectToProfile]="true"
                [defaultAvatarUrl]="defaultAvatarUrl"
              ></unh-user-avatar>
            </div>
            <div class="quill-wrapper">
              <!-- <quill-editor
              #quillInstance
              [modules]="QuillModules"
              [placeholder]="'Comece a digitar aqui...'"
              [maxLength]="1000"
              [trimOnValidation]="true"

              ></quill-editor> -->

              <unh-comment-quill-editor
              (onImagesChanged)="onImagesChanged($event)"
              (onEditorChanged)="onTextChanged($event)"
              (onEditorCreated)="getQuillInstance($event)"
              ></unh-comment-quill-editor>
            </div>
            <!-- <textarea
              #textAreaRootComment
              class="input-root-comment"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
              placeholder="Escreva algo aqui..."
              id="root-comment"
            ></textarea> -->
          </div>

          <div class="btn-publish">
            <a
                mat-button
                theme="pink-white"
                class="unh-button-old"
                [disabled]="submitDisabled"
                (click)="!submitDisabled ? submitComment() : null"
            >
                Publicar
            </a>
          </div>
        </div>
      </div>
  </div>

